import React, { Component } from "react"
import styled from "styled-components"
import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"
import { TinyButtonWhite } from "./Button"

const SectionContent = styled.div`
  position: relative;
  z-index: 3;
  width: ${props => props.width};
  min-height: ${props => props.height};
  top: ${props => props.positionTB};
  display: flex;
  flex-direction: column;
  align-items: ${props => props.align};
  justify-content: ${props => props.justify};
  margin: 25px auto;
  padding: 0px 50px;
  color: ${props =>
    props.color ? "rgba(90, 88, 94, 1)" : "rgba(255,255,255,1)"};
  h1 {
    margin-bottom: 25px;
  }
  h3 {
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 10px;
  }
  @media screen and (max-width: 768px) {
    padding: 0px 25px;
  }
  @media screen and (max-width: 615px) {
    padding: 0px 10px;
  }
`

export default SectionContent



// WEBPACK FOOTER //
// ./src/components/SectionContent.js